<template>
  <!-- 应用bottomcolor作为背景颜色，添加渐变效果 -->
  <div class="page-container" :style="{
    'color': textColor
  }" :class="{ 'has-bg-image': backgroundImageUrl }">
    <div class="background-layer" :style="{ 'background-image': `url(${backgroundImageUrl})` }"></div>
    <!-- 用户登录/信息区域 - 更现代化的设计 -->
    <div class="user-area">
      <div class="user-info-box" v-if="isLoggedIn">
        <div class="user-avatar-wrapper" @click="showDropdown = !showDropdown">
          <el-avatar :size="45" :src="userInfo.face" class="user-avatar" />
          <div class="user-badge">
            <el-icon>
              <StarFilled />
            </el-icon>
          </div>
        </div>

        <transition name="el-zoom-in-top">
          <div v-if="showDropdown" class="user-dropdown-menu">
            <div class="dropdown-header">
              <el-avatar :size="52" :src="userInfo.face" class="dropdown-avatar" />
              <div class="user-details">
                <h3>{{ userInfo.uname }}</h3>
                <p class="user-id">UID: {{ userInfo.mid }}</p>
                <p class="user-integral">积分: {{ settingData.Integral }}</p>
              </div>
            </div>

            <div class="dropdown-divider"></div>

            <div class="dropdown-item" @click="logout2">
              <el-icon>
                <SwitchButton />
              </el-icon>
              <span>退出登录</span>
            </div>
          </div>
        </transition>
      </div>

      <div class="login-entry" v-else>
        <el-button type="primary" size="small" @click="goToLogin" :icon="User" class="login-button">
          登录
        </el-button>
      </div>
    </div>

    <!-- 导航栏 - 玻璃拟态设计 -->
    <nav class="navbar">
      <ul class="nav-list">
        <li class="nav-item" v-for="item in shownNav" :key="item.path" 
            :class="{ 'active': isActive(item.path) }">
          <router-link :to="item.path" 
                      :style="{ 'background-color': settingData.Navigationcolor || 'rgba(0, 0, 0, 0.7)' }">
            <el-icon :size="18" class="nav-icon">
              <component :is="item.icon" />
            </el-icon>
            <span>{{ item.name }}</span>
          </router-link>
        </li>
      </ul>
    </nav>

    <!-- 主内容区域 - 卡片玻璃拟态效果 -->
    <div class="link-integral-container" :style="{ '--theme-color': settingData.color || '#ffffff' }">
      <el-card class="main-card glass-effect" shadow="hover" 
              :style="{ 'background-color': cardBackgroundColor }">
        <template #header>
          <div class="header-title">
            <el-icon class="title-icon">
              <Link />
            </el-icon>
            <span>{{ settingData.nickname }}的虚拟空间</span>
          </div>
        </template>

        <!-- 歌单管理区域 -->
        <div class="music-playlist-container">
          <!-- 筛选工具栏 -->
          <div class="toolbar">
            <el-input v-model="searchQuery" placeholder="搜索歌曲" clearable class="search-input">
              <template #append>
                <el-button @click="fetchMusicList">
                  <el-icon>
                    <Search />
                  </el-icon>
                </el-button>
              </template>
            </el-input>

            <!-- 分类选择 -->
            <el-select v-model="selectedCategory" placeholder="选择分类" class="category-select"
              :disabled="isCategoryLoading">
              <el-option label="全部" value="" />
              <el-option v-for="category in categories" :key="category.value" :label="category.label"
                :value="category.value" />
            </el-select>

            <!-- 付费状态筛选 -->
            <el-select v-model="selectedPayStatus" placeholder="付费状态" class="pay-select">
              <el-option label="全部" value="" />
              <el-option label="免费" value="免费" />
              <el-option label="付费" value="付费" />
              <el-option label="SC点歌" value="SC点歌" />
            </el-select>
          </div>

          <!-- 数据加载状态 -->
          <div class="loading-state" v-if="loading">
            <el-skeleton :count="6" animated />
          </div>

          <!-- 歌单列表 -->
          <div class="music-list" v-else>
            <div v-if="musicList.length === 0" class="empty-state">
              <el-icon class="empty-icon">
                <Music />
              </el-icon>
              <h3>暂无歌曲</h3>
              <p>点击"添加歌曲"按钮开始创建你的歌单</p>
            </div>

            <!-- 气泡样式列表 -->
            <div v-if="musicList.length != 0" class="bubble-list">
              <div 
                v-for="(song, index) in filteredMusicList" 
                :key="song.id" 
                class="bubble-item"
                :style="{ backgroundColor: getRandomLightColor(index) }"
              >
                <div class="bubble-content">
                  <div class="song-index">{{ index + 1 }}</div>
                  
                  <div class="song-main">
                    <div class="song-title">{{ song.music }}</div>
                    <div class="song-tags">
                      <el-tag :type="getCategoryType(song.class)" size="small" effect="light">
                        {{ song.class }}
                      </el-tag>
                    </div>
                  </div>
                  
                  <div class="song-actions">
                    <div 
                      class="pay-status-badge"
                      :class="{ 'free': !song.pay || song.pay === '免费', 'paid': song.pay === '付费' }"
                    >
                      <div class="badge-icon">
                        <el-icon>
                          <component :is="song.pay === '付费' ? 'Lock' : 'Unlock'" />
                        </el-icon>
                      </div>
                      <span class="badge-text">{{ song.pay || '免费' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 删除确认对话框 -->
          <el-dialog v-model="deleteDialogVisible" title="确认删除" width="500px" custom-class="detail-dialog">
            <p>确定要删除这首歌曲吗？</p>
            <template #footer>
              <el-button @click="deleteDialogVisible = false">取消</el-button>
              <el-button type="danger" @click="confirmDelete">确认删除</el-button>
            </template>
          </el-dialog>
        </div>
      </el-card>
    </div>
  </div>

  
  <div class="floating-button-container">
    <el-tooltip content="反馈" placement="left">
      <el-button class="floating-button" type="primary" circle :style="{ width: '56px', height: '56px' }"
        @click="handleClick">
        <el-icon size="30">
          <Service />
        </el-icon>
      </el-button>
    </el-tooltip>
  </div>

  <!-- 反馈表单对话框 -->
  <el-dialog v-model="floatingVisible" title="用户反馈" width="500px" custom-class="feedback-dialog"
    :close-on-click-modal="false">
    <el-form :model="feedbackForm" :rules="feedbackRules" ref="feedbackFormRef" label-width="100px">
      <el-form-item label="你的B站UID" prop="userId">
        <el-input v-model="feedbackForm.userId" placeholder="请输入你的用户ID"></el-input>
      </el-form-item>

      <el-form-item label="问题类型" prop="problemType">
        <el-select v-model="feedbackForm.problemType" placeholder="请选择问题类型">
          <el-option label="加群审核" value="加群审核"></el-option>
          <el-option label="禁言申诉" value="禁言申诉"></el-option>
          <el-option label="私信补发" value="私信补发"></el-option>
          <el-option label="音声礼物" value="音声礼物"></el-option>
          <el-option label="物流相关" value="物流相关"></el-option>
          <el-option label="其他" value="其他"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="问题描述" prop="problemDesc">
        <el-input v-model="feedbackForm.problemDesc" type="textarea" :rows="4" placeholder="请详细描述你的问题..."></el-input>
      </el-form-item>

      <el-form-item label="QQ联系方式" prop="contactInfo">
        <el-input v-model="feedbackForm.contactInfo" placeholder="请留下联系方式以便回复"></el-input>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="floatingVisible = false">取消</el-button>
        <el-button type="primary" @click="submitFeedback">提交反馈</el-button>
      </span>
    </template>
  </el-dialog>

    <!-- 在template部分的最后，floating-button-container之后添加备案号 -->
  <div class="footer-record">
    <div class="record-text" :style="{ 'color': textColor }">
      <a href="https://beian.miit.gov.cn/" target="_blank" :style="{ 'color': textColor }">
        陕ICP备2025066285号-2
      </a>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed, watch, onUnmounted } from 'vue';
import { ElMessage } from 'element-plus';
import {
  Link,
  Search,
  Music,
  Delete,
  VideoPlay,
  User,
  StarFilled,
  SwitchButton,
  HomeFilled,
  Calendar,
  Collection,
  Present,
  Headset,
  InfoFilled,Service,
  Coin,
  Lock,
  Unlock
} from '@element-plus/icons-vue';
import axios from 'axios';
import { useRoute, useRouter } from 'vue-router';
import { ASSET_BASE } from '../../util/assetBase';

const route = useRoute();
const router = useRouter();

// 导航项配置
const navItems = [
  { path: '/', name: '首页', icon: HomeFilled },
  { path: '/works', name: '作品', icon: Collection },
  { path: '/points', name: '积分兑换', icon: Coin },
  { path: '/captain', name: '舰长礼物', icon: Present },
  { path: '/songlist', name: '歌单', icon: Headset },
  { path: '/livecalendar', name: '直播日历', icon: 'Calendar' },
  { path: '/about', name: '关于', icon: InfoFilled }
];

// 一场直播记录都还没有的时候，导航里的「直播日历」就不出现（后台录一场，它自己就回来）
const liveCount = ref(0);
// 主人要求：直播日历这一项所有域名都显示（原来是「有直播记录才出现」，
// 结果子域名那几个库是空的，整个入口都看不见了）
const shownNav = computed(() => navItems.slice());
axios.get('/adminapi/live/list?_=' + Date.now()).then((r) => { liveCount.value = Number((r.data && r.data.count) || 0); }).catch(() => {});

// 判断当前路由是否激活
const isActive = (path) => {
  return route.path === path;
};

// 计算文本颜色基于背景色
const textColor = computed(() => {
  const bgColor = settingData.bottomcolor || '#000000';
  // 简单计算背景亮度决定文字颜色
  const color = bgColor.replace('#', '');
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128 ? '#333' : '#fff';
});

// 计算卡片背景颜色
const cardBackgroundColor = computed(() => {
  const bgColor = settingData.backcolor || 'rgba(255, 255, 255, 0.9)';
  if (bgColor.includes('rgba')) {
    // 如果是rgba，增加透明度
    return bgColor.replace(/[\d\.]+\)$/, '0.85)');
  }
  return bgColor;
});

// 用户信息
const isLoggedIn = ref(false);
const userInfo = reactive({
  uname: '',
  mid: '',
  face: ''
});
const showDropdown = ref(false);

// 点击空白处关闭下拉菜单
const handleClickOutside = (event) => {
  const userArea = document.querySelector('.user-area');
  if (userArea && !userArea.contains(event.target)) {
    showDropdown.value = false;
  }
};

// 检查登录状态
const checkLoginStatus = () => {
  const savedUserInfo = localStorage.getItem('userInfo');
  if (savedUserInfo) {
    try {
      const parsedInfo = JSON.parse(savedUserInfo);
      if (parsedInfo.mid) {
        Object.assign(userInfo, parsedInfo);
        isLoggedIn.value = true;
      }
    } catch (e) {
      console.error('解析用户信息失败:', e);
      localStorage.removeItem('userInfo');
    }
  }
};

// 登录跳转
const goToLogin = () => {
  router.push('/user/login');
};

// 退出登录
const logout = async () => {
  try {
    localStorage.removeItem('userInfo');
    isLoggedIn.value = false;
    userInfo.uname = '';
    userInfo.mid = '';
    userInfo.face = '';
    showDropdown.value = false;
    settingData.Integral = 0;
    
    if (route.path.startsWith('/user')) {
      router.push('/');
    }
    
    
  } catch (error) {
    console.error('退出登录失败:', error);
  }
};

// 获取用户积分
const UserIntegral = async (usermid) => {
  try {
    const response = await axios.post('/adminapi/userapi/integral/check', {
      uid: usermid
    });
    settingData.Integral = response.data.results[0]?.integral || 0;
  } catch (error) {
    console.error('查询积分失败:', error);
    settingData.Integral = 0;
  }
}

// 获取用户信息
const fetchUserInfo = async () => {
  try {
    const response = await axios.get('/adminapi/user/Bmsg', {
      withCredentials: true
    });

    if (response.data.code === 0 && response.data.data) {
      const userData = response.data.data;
      userInfo.uname = userData.uname || '';
      userInfo.mid = userData.mid || '';
      userInfo.face = await setBilibiliAvatar(userData.face);
      isLoggedIn.value = true;
      UserIntegral(userInfo.mid);
      
      localStorage.setItem('userInfo', JSON.stringify({
        uname: userInfo.uname,
        mid: userInfo.mid,
        face: userInfo.face
      }));
    } else {
      console.error("获取用户信息失败:", response.data.message);
      logout();
    }
  } catch (error) {
    console.error('请求用户信息失败:', error);
    logout();
  }
};

const setBilibiliAvatar = async (str) => {
  try {
    const response = await axios.post('/adminapi/user/avater', {
      face: str,
    }, {
      responseType: 'arraybuffer',
      withCredentials: true
    });

    const base64 = btoa(
      new Uint8Array(response.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ''
      )
    );

    return `data:image/jpeg;base64,${base64}`;
  } catch (error) {
    console.error('获取头像失败:', error);
    return '/default-avatar.png';
  }
}

// 背景图片URL
const backgroundImageUrl = ref('');

// 主播信息数据
const settingData = reactive({
  nickname: '',
  slogan: '',
  homepageImage: '',
  color: '#ffffff',
  backcolor: 'rgba(255, 255, 255, 0.85)',
  Navigationcolor: 'rgba(0, 0, 0, 0.7)',
  bottomcolor: '#000000',
  Integral: 0
});

// 歌单管理状态
const musicList = ref([]);
const categories = ref([]);
const searchQuery = ref('');
const selectedCategory = ref('');
const selectedPayStatus = ref(''); // 新增付费状态筛选
const loading = ref(false);
const isCategoryLoading = ref(false);
const deleteDialogVisible = ref(false);
const currentDeleteId = ref(null);

// 计算属性：过滤后的歌曲列表
const filteredMusicList = computed(() => {
  if (!musicList.value.length) return [];
  
  return musicList.value.filter(song => {
    const searchMatch = !searchQuery.value ||
      song.music?.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
      song.class?.toLowerCase().includes(searchQuery.value.toLowerCase());

    const categoryMatch = !selectedCategory.value ||
      song.class === selectedCategory.value;

    const payMatch = !selectedPayStatus.value ||
      (song.pay || '免费') === selectedPayStatus.value;
    console.log(selectedPayStatus.value)
    return searchMatch && categoryMatch && payMatch;
  });
});

// 获取主播信息和背景图片
const fetchSettingData = async () => {
  try {
    const response = await axios.get('/adminapi/setting/list');
    const data = response.data.results[0] || {};

    settingData.nickname = data.title || '塔娅娅';
    settingData.slogan = data.content || '只是想成为一个可爱的虚拟小地偶';
    settingData.homepageImage = data.homepageImage || '';
    settingData.color = data.color || '#ffffff';
    settingData.backcolor = data.backcolor || 'rgba(255, 255, 255, 0.85)';
    settingData.Navigationcolor = data.Navigationcolor || 'rgba(0, 0, 0, 0.7)';
    settingData.bottomcolor = data.bottomcolor || '#000000';
        const defaultBackground = 'https://s.panlai.com/zb_users/upload/2025/05/20250506082830174649131053424.jpg';
    backgroundImageUrl.value = data.page ? ASSET_BASE + data.page : defaultBackground;
  } catch (error) {
    console.error('加载设置数据错误:', error);
  }
};

// 获取分类列表
const fetchCategoryList = async () => {
  isCategoryLoading.value = true;
  try {
    const res = await axios.get('/adminapi/class/list');
    categories.value = res.data.results.map(item => ({
      label: item.class || item.value,
      value: item.class || item.value
    }));
  } catch (error) {
    console.error('分类加载失败:', error);
    ElMessage.error('分类加载失败，请重试');
    categories.value = [];
  } finally {
    isCategoryLoading.value = false;
  }
};

// 获取音乐列表
const fetchMusicList = async () => {
  loading.value = true;
  try {
    const res = await axios.get('/adminapi/music/list', {
      params: {
        category: selectedCategory.value || undefined
      }
    });
    musicList.value = res.data.results || [];
  } catch (error) {
    console.error('歌曲加载失败:', error);
    ElMessage.error('歌曲加载失败，请重试');
    musicList.value = [];
  } finally {
    loading.value = false;
  }
};
const logout2 = async () => {
  try {
    localStorage.removeItem('userInfo');
    isLoggedIn.value = false;
    userInfo.uname = '';
    userInfo.mid = '';
    userInfo.face = '';
    showDropdown.value = false;
    settingData.Integral = 0;

    if (route.path.startsWith('/user')) {
      router.push('/');
    }
    ElMessage.success('已退出登录');
  } catch (error) {
    console.error('退出登录失败:', error);
  }
};

// 播放歌曲
const playSong = (song) => {
  console.log('播放歌曲:', song);
  // 这里可以添加播放逻辑
};

// 删除歌曲
const deleteSong = (id) => {
  currentDeleteId.value = id;
  deleteDialogVisible.value = true;
};

// 确认删除
const confirmDelete = async () => {
  if (!currentDeleteId.value) return;

  try {
    await axios.delete(`/adminapi/music/${currentDeleteId.value}`);
    musicList.value = musicList.value.filter(song => song.id !== currentDeleteId.value);
    ElMessage.success('歌曲删除成功');
  } catch (error) {
    console.error('删除失败:', error);
    ElMessage.error('删除失败，请稍后重试');
  } finally {
    deleteDialogVisible.value = false;
  }
};

// 分类标签类型映射
const getCategoryType = (category) => {
  const typeMap = {
    pop: 'primary',
    rock: 'danger',
    jazz: 'warning',
    classical: 'info',
    electronic: 'success'
  };
  return typeMap[category] || 'info';
};

// 付费状态标签类型映射
const getPayType = (payStatus) => {
  const typeMap = {
    '免费': 'success',
    '付费': 'warning'
  };
  return typeMap[payStatus] || 'success';
};

// 生成浅色系随机颜色
const getRandomLightColor = (index) => {
  const lightColors = [
    '#fef7f0', // 浅橙色
    '#f0f9ff', // 浅蓝色
    '#f0fdf4', // 浅绿色
    '#fefce8', // 浅黄色
    '#fdf2f8', // 浅粉色
    '#f5f3ff', // 浅紫色
    '#ecfdf5', // 浅薄荷绿
    '#fff7ed', // 浅桃色
    '#f0fdfa', // 浅青色
    '#fdf4ff', // 浅淡紫色
    '#f8fafc', // 浅灰蓝
    '#fffbeb', // 浅米色
  ];
  
  // 使用索引来确保颜色分布均匀，但看起来随机
  return lightColors[index % lightColors.length];
};

// 监听分类变化
watch([selectedCategory, selectedPayStatus], () => {
  fetchMusicList();
});

onMounted(() => {
  checkLoginStatus();
  fetchUserInfo();
  fetchSettingData();
  fetchCategoryList();
  fetchMusicList();

  // 添加全局点击事件监听
  document.addEventListener('click', handleClickOutside);
});

// 组件卸载时移除事件监听
onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

// 点击事件处理
const floatingVisible = ref(false);
// 反馈表单数据
const feedbackForm = reactive({
  userId: '',
  problemType: '',
  problemDesc: '',
  contactInfo: '',
  time: '',
  Solve: '未解决',
  id: ''
});
const generateId = () => {
  // 方法1: 使用时间戳和随机数生成唯一ID
  const timestamp = Date.now().toString(36)
  const random = Math.random().toString(36).substr(2, 5)
  var nameid = `${timestamp}${random}`
  return nameid

}
const feedbackFormRef = ref(null);
const feedbackRules = reactive({
  userId: [{ required: true, message: '请输入你的B站UID', trigger: 'blur' }],
  problemType: [{ required: true, message: '请选择问题类型', trigger: 'change' }],
  problemDesc: [{ required: true, message: '请描述你的问题', trigger: 'blur' }],
  contactInfo: [{ required: true, message: '请留下联系方式', trigger: 'blur' }]
});
const handleClick = () => {
  console.log('反馈按钮被点击')
  floatingVisible.value = true
}
const submitFeedback = async () => {
  // 表单声明了 :rules 却从不校验，空字段会直接写进 Feedback 表
  if (feedbackFormRef.value) {
    try {
      await feedbackFormRef.value.validate();
    } catch (e) {
      return; // 校验不通过，字段下方已有提示
    }
  }
  feedbackForm.time = formatTime(Date.now())
  feedbackForm.id = generateId()
  try {
    var response = await axios.post('/adminapi/Feedback/add', feedbackForm)
    if (response.data && response.data.code === 200) {
      floatingVisible.value = false
      ElMessage.success('反馈成功');
      resetFeedbackForm()
    } else {
      floatingVisible.value = false
      ElMessage.error((response.data && response.data.message) || '反馈失败');
    }
  } catch (error) {
    console.error('反馈提交失败:', error)
    floatingVisible.value = false
    ElMessage.error('反馈失败，请稍后重试');
  }
}
const formatTime = (time) => {
  const date = new Date(time);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hour}:${minute}`;
};
const resetFeedbackForm = () => {
  feedbackForm.userId = '';
  feedbackForm.problemType = '';
  feedbackForm.problemDesc = '';
  feedbackForm.contactInfo = '';
  feedbackForm.time = '';
  feedbackForm.Solve = '未解决';
  feedbackForm.id = '';
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
:root {
  --glass-blur: 8px;
  --glass-border: 1px solid rgba(255, 255, 255, 0.18);
  --glass-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.page-container {
  min-height: 100vh;
  padding: 20px;
  position: relative;
  background: none !important;
  /* 移除任何背景设置 */
}

.page-container::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  opacity: 0.1;
  z-index: -1;
  /* 使用CSS变量动态设置背景图片 */
  background-image: var(--bg-image, url('https://s.panlai.com/zb_users/upload/2025/05/20250506082830174649131053424.jpg'));
}

.page-container.has-bg-image {
  background-image: url('');
  /* 这里通过JS动态设置 */
}

/* 用户区域样式 - 更现代化的设计 */
.user-area {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 100;

  .user-info-box {
    position: relative;

    .user-avatar-wrapper {
      position: relative;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.05);

        .user-badge {
          transform: translate(30%, -30%) scale(1.2);
        }
      }

      .user-avatar {
        border: 2px solid rgba(255, 255, 255, 0.8);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transition: all 0.3s ease;
      }

      .user-badge {
        position: absolute;
        top: 0;
        right: 0;
        background: linear-gradient(135deg, #ff4081, #7b1fa2);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 12px;
        transform: translate(30%, -30%);
        transition: transform 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        z-index: 1;

        .el-icon {
          width: 12px;
          height: 12px;
        }
      }
    }

    .user-dropdown-menu {
      position: absolute;
      top: 60px;
      right: 0;
      width: 260px;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
      overflow: hidden;
      z-index: 200;
      backdrop-filter: blur(var(--glass-blur));
      border: var(--glass-border);

      .dropdown-header {
        padding: 20px;
        display: flex;
        background: linear-gradient(135deg, rgba(245, 247, 250, 0.8), rgba(228, 231, 235, 0.8));
        border-bottom: 1px solid rgba(238, 238, 238, 0.5);

        .dropdown-avatar {
          margin-right: 15px;
          border: 3px solid white;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }

        .user-details {
          flex: 1;

          h3 {
            margin: 0 0 5px;
            color: #333;
            font-weight: 600;
            font-size: 16px;
          }

          .user-id {
            margin: 0;
            color: #666;
            font-size: 12px;
          }
          
          .user-integral {
            margin: 5px 0 0;
            color: #e6a23c;
            font-size: 14px;
            font-weight: bold;
          }
        }
      }

      .dropdown-divider {
        height: 1px;
        background: rgba(238, 238, 238, 0.5);
        margin: 0 15px;
      }

      .dropdown-item {
        padding: 12px 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #666;
        font-weight: 500;
        transition: all 0.2s ease;

        &:hover {
          background: rgba(245, 247, 250, 0.8);
          color: #ff4081;

          .el-icon {
            color: #ff4081;
          }
        }

        .el-icon {
          margin-right: 10px;
          font-size: 16px;
          color: #777;
          transition: color 0.2s ease;
        }
      }
    }
  }
}

.login-entry {
  .login-button {
    background: linear-gradient(135deg, #6a11cb, #2575fc);
    border: none;
    border-radius: 20px;
    padding: 8px 20px;
    box-shadow: 0 4px 10px rgba(37, 117, 252, 0.3);
    transition: all 0.3s ease;
    font-weight: 500;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 12px rgba(37, 117, 252, 0.4);

      .el-icon {
        transform: translateX(3px);
      }
    }

    .el-icon {
      transition: transform 0.3s ease;
    }
  }
}

/* 导航栏样式 - 玻璃拟态设计 */
.navbar {
  position: relative;
  z-index: 1;
  margin-bottom: 30px;
  backdrop-filter: blur(var(--glass-blur));

  .nav-list {
    display: flex;
    justify-content: center;
    list-style: none;
    padding: 0;
    margin: 0;
    flex-wrap: wrap;
    gap: 10px;
  }

  .nav-item {
    a {
      color: white;
      text-decoration: none;
      font-size: 15px;
      padding: 10px 18px;
      border-radius: 20px;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      backdrop-filter: blur(var(--glass-blur));
      border: var(--glass-border);
      
      &:hover {
        opacity: 0.9;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      }
      
      &.router-link-active {
        box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
        font-weight: bold;
      }
      
      .nav-icon {
        margin-right: 8px;
      }
    }
  }
}

/* 玻璃拟态效果 */
.glass-effect {
  backdrop-filter: blur(var(--glass-blur));
  border: var(--glass-border) !important;
  box-shadow: var(--glass-shadow) !important;
  background: rgba(255, 255, 255, 0.85) !important;
}

.link-integral-container {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;

  .main-card {
    border-radius: 16px !important;
    overflow: hidden;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15) !important;
    }
  }

  .header-title {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: var(--theme-color);
    padding: 10px 0;

    .title-icon {
      margin-right: 10px;
      color: var(--theme-color);
      font-size: 20px;
    }
  }
}

/* 歌单管理区域样式 */
.music-playlist-container {
  padding: 20px;

  .toolbar {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
    flex-wrap: wrap;

    .search-input {
      flex: 1;
      min-width: 250px;
      max-width: 400px;

      :deep(.el-input-group__append) {
        background-color: var(--theme-color);
        color: white;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        transition: all 0.3s ease;

        &:hover {
          background-color: lighten(#409EFF, 10%);
        }
      }
    }

    .category-select {
      width: 200px;
    }

    .pay-select {
      width: 150px;
    }
  }

  .loading-state {
    padding: 20px 0;
  }

  .empty-state {
    text-align: center;
    padding: 40px 0;
    color: #909399;

    .empty-icon {
      font-size: 48px;
      margin-bottom: 15px;
    }

    h3 {
      margin: 10px 0;
      font-weight: normal;
    }

    p {
      margin: 0;
      font-size: 14px;
    }
  }

  .custom-table {
    --el-table-border-color: rgba(0, 0, 0, 0.08);
    --el-table-header-bg-color: #f8fafc;
    --el-table-row-hover-bg-color: #f5f7fa;
    border-radius: 8px;
    overflow: hidden;
    
    th {
      font-weight: 600;
      background-color: var(--el-table-header-bg-color) !important;
      color: #606266;
      font-size: 14px;
    }
    
    .song-index {
      font-weight: 600;
      color: #909399;
      font-size: 16px;
    }
    
    .song-info {
      .song-name {
        font-weight: 600;
        font-size: 16px;
        color: #303133;
        margin-bottom: 8px;
        line-height: 1.4;
      }
      
      .song-meta {
        display: flex;
        gap: 8px;
        align-items: center;
        
        .pay-tag {
          font-size: 12px;
        }
      }
    }
    
    .song-status {
      display: flex;
      justify-content: center;
      
      .el-tag {
        display: flex;
        align-items: center;
        gap: 4px;
        
        .status-icon {
          font-size: 12px;
        }
      }
    }
    
    .action-buttons {
      display: flex;
      justify-content: center;
      gap: 8px;
      
      .el-button {
        transition: all 0.3s ease;
        
        &:hover:not(:disabled) {
          transform: scale(1.1);
        }
        
        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }
  }

  // 气泡列表样式
  .bubble-list {
    /* 一行两首（原来是一行一首的竖排）；窄屏自动退回一列 */
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;

    @media (max-width: 900px) {
      grid-template-columns: minmax(0, 1fr);
    }

    
    .bubble-item {
      border-radius: 16px;
      padding: 16px 20px;
      transition: all 0.3s ease;
      border: 1px solid rgba(255, 255, 255, 0.3);
      backdrop-filter: blur(10px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
        border-color: rgba(255, 255, 255, 0.5);
      }
      
      .bubble-content {
        display: flex;
        align-items: center;
        gap: 16px;
        
        .song-index {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          color: #606266;
          font-size: 14px;
          flex-shrink: 0;
        }
        
        .song-main {
          flex: 1;
          min-width: 0;
          
          .song-title {
            font-size: 16px;
            font-weight: 600;
            color: #303133;
            margin-bottom: 8px;
            line-height: 1.4;
            word-break: break-all;
          }
          
          .song-tags {
            display: flex;
            gap: 8px;
            align-items: center;
            flex-wrap: wrap;
            
            .el-tag {
              display: flex;
              align-items: center;
              gap: 4px;
              
              .tag-icon {
                font-size: 12px;
              }
            }
          }
        }
        
        .song-actions {
          flex-shrink: 0;
          
          .pay-status-badge {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 10px 16px;
            border-radius: 25px;
            font-weight: 600;
            font-size: 13px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            cursor: default;
            position: relative;
            overflow: hidden;
            
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: -100%;
              width: 100%;
              height: 100%;
              background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
              transition: left 0.5s;
            }
            
            &:hover::before {
              left: 100%;
            }
            
            .badge-icon {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background: rgba(255, 255, 255, 0.2);
              transition: all 0.3s ease;
              
              .el-icon {
                font-size: 12px;
              }
            }
            
            .badge-text {
              font-weight: 600;
              letter-spacing: 0.5px;
            }
            
            &.free {
              background: linear-gradient(135deg, #10b981, #059669);
              color: white;
              box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
              
              &:hover {
                transform: translateY(-2px) scale(1.05);
                box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
                
                .badge-icon {
                  background: rgba(255, 255, 255, 0.3);
                  transform: rotate(360deg);
                }
              }
            }
            
            &.paid {
              background: linear-gradient(135deg, #f59e0b, #d97706);
              color: white;
              box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
              
              &:hover {
                transform: translateY(-2px) scale(1.05);
                box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4);
                
                .badge-icon {
                  background: rgba(255, 255, 255, 0.3);
                  transform: rotate(-10deg);
                }
              }
            }
          }
        }
      }
    }
  }
}

/* 响应式调整 */
@media (max-width: 992px) {
  .toolbar {
    flex-direction: column;
    
    .search-input {
      max-width: 100%;
    }
    
    .category-select,
    .pay-select {
      width: 100%;
    }
  }
}

@media (max-width: 768px) {
  .page-container {
    padding: 15px;
  }
  
  .user-area {
    top: 15px;
    right: 15px;
    
    .user-info-box .user-dropdown-menu {
      width: 240px;
    }
  }

  .navbar {
    margin-bottom: 20px;
    
    .nav-list {
      gap: 8px;
    }
    
    .nav-item a {
      padding: 8px 15px;
      font-size: 14px;
    }
  }
  
  .music-playlist-container {
    padding: 15px;
    
    .bubble-list { gap: 10px; }
    
    .bubble-list .bubble-item {
      padding: 12px 14px;
      
      .bubble-content {
        gap: 12px;
        
        .song-index {
          width: 28px;
          height: 28px;
          font-size: 12px;
        }
        
        .song-main .song-title {
          font-size: 14px;
        }
        
        .song-actions .pay-status-badge {
          padding: 8px 12px;
          font-size: 12px;
          
          .badge-icon {
            width: 18px;
            height: 18px;
            
            .el-icon {
              font-size: 10px;
            }
          }
          
          .badge-text {
            font-size: 11px;
          }
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .user-area {
    .login-entry .login-button {
      padding: 6px 15px;
      font-size: 13px;
    }
    
    .user-info-box .user-dropdown-menu {
      width: 220px;
    }
  }
  
  .navbar .nav-item a {
    padding: 6px 12px;
    font-size: 13px;
    
    .nav-icon {
      margin-right: 5px;
    }
  }
  
  .category-select {
    width: 100% !important;
  }
  
  .pay-select {
    width: 100% !important;
  }
  
  .bubble-list .bubble-item {
    .bubble-content {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
      
      .song-index {
        align-self: flex-start;
      }
      
      .song-actions {
        align-self: flex-end;
      }
    }
  }
}
.floating-button-container {
  display: flex;
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
}

.floating-button {

  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  background-color: #409EFF;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  width: 56px;
  height: 56px;

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  }

  &:active {
    transform: scale(0.95);
  }
}
.background-layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  z-index: -1;
  /* 确保在内容层下方 */
  // filter: brightness(0.7);
  /* 适当降低亮度增加可读性 */

  /* 如果需要覆盖渐变效果 */

}
/* 在style部分添加备案号样式 */
.footer-record {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
  padding: 8px 0;
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.2);
  
  .record-text {
    font-size: 12px;
    letter-spacing: 0.5px;
    
    a {
      text-decoration: none;
      transition: opacity 0.3s;
      
      &:hover {
        opacity: 0.8;
        text-decoration: underline;
      }
    }
  }
}
</style>